import axios from 'axios'
import moment from 'moment'
axios.defaults.baseURL = process.env.VUE_APP_API_URL


// Request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // config.headers["Authorization"] = "bearer " + getToken();
  if(config.url != "auth/login" && moment().isAfter(localStorage.getItem('expire-token'))){
    console.log('TOKEN EXPIRED');
    // clear token
    localStorage.removeItem('user-token')
    // redirect
    window.location.replace("/");
  }

  config.headers["Authorization"] = "bearer " + (localStorage.getItem('user-token')? localStorage.getItem('user-token') : null);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
